import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-house__wrapper"
}
const _hoisted_2 = { class: "card-house__image-wrapper" }
const _hoisted_3 = ["src", "srcset", "alt"]
const _hoisted_4 = ["src", "srcset", "alt"]
const _hoisted_5 = ["src", "srcset", "alt"]
const _hoisted_6 = { class: "card-house__body" }
const _hoisted_7 = { class: "card-house__body-title" }
const _hoisted_8 = {
  key: 0,
  class: "card-house__body-list"
}
const _hoisted_9 = { class: "card-house__body-list-item" }
const _hoisted_10 = {
  key: 0,
  class: "card-house__body-list-item-label"
}
const _hoisted_11 = {
  key: 1,
  class: "card-house__body-list-item-label"
}
const _hoisted_12 = { class: "card-house__body-list-item-value" }
const _hoisted_13 = { class: "card-house__body-list-item" }
const _hoisted_14 = { class: "card-house__body-list-item-value" }
const _hoisted_15 = {
  key: 1,
  class: "card-house__void"
}

import { computed, ref } from 'vue';
import { landPlotStore } from '@/store/modules/LandPLot';
import { cardSettingsStore } from '@/store/modules/CardSettings';
import { getURL } from '@/helpers/routeHelpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'CardPlot',
  setup(__props) {

const houseCard = ref<HTMLElement | null>(null);

const statusCardPlotShow = computed(() => {
    return cardSettingsStore.STATUS_CARD_PLOT_ZONE_SHOW;
});

const objectStyle = computed(() => {
    let left = position.value.width / 2 + position.value.left;

    if (houseCard.value && houseCard.value instanceof Element) {
        const widthCard = houseCard.value.clientWidth;

        left = left - widthCard / 2;
    }

    return {
        left: `${left}px`,
        bottom: `calc(100% - ${position.value.bottom - position.value.topMap
            }px + ${position.value.height / 2}px)`,
        opacity: statusCardPlotShow.value ? '1' : '0',
    };
});

const card = computed(() => {
    return landPlotStore.LAND_PLOT_CARD_ZONE;
});

const position = computed(() => {
    return cardSettingsStore.POSITION_CARD_PLOT_ZONE;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "card-house card-plot",
    style: _normalizeStyle(objectStyle.value),
    ref_key: "houseCard",
    ref: houseCard
  }, [
    (card.value && Object.keys(card.value).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (card.value.id === 'southeast')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "card-house__image",
                  src: `${_unref(getURL)()}/${require('@/assets/img/Map/kv-8-11.jpg')}`,
                  srcset: `
                        ${_unref(getURL)()}/${require('@/assets/img/Map/kv-8-11@2x.jpg')} 2x,
                        ${_unref(getURL)()}/${require('@/assets/img/Map/kv-8-11@3x.jpg')} 3x
                    `,
                  alt: card.value.title
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
            (card.value.id === 'southwest')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "card-house__image",
                  src: `${_unref(getURL)()}/${require('@/assets/img/Map/kv-8-11.jpg')}`,
                  srcset: `
                        ${_unref(getURL)()}/${require('@/assets/img/Map/kv-8-11@2x.jpg')} 2x,
                        ${_unref(getURL)()}/${require('@/assets/img/Map/kv-8-11@3x.jpg')} 3x
                    `,
                  alt: card.value.title
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            (card.value.id === 'northeast')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 2,
                  class: "card-house__image",
                  src: `${_unref(getURL)()}/${require('@/assets/img/Map/kv-1.jpg')}`,
                  srcset: `
                        ${_unref(getURL)()}/${require('@/assets/img/Map/kv-1@2x.jpg')} 2x,
                        ${_unref(getURL)()}/${require('@/assets/img/Map/kv-1@3x.jpg')} 3x
                    `,
                  alt: card.value.title
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", _hoisted_7, _toDisplayString(card.value.title), 1),
            (card.value.params && Object.keys(card.value.params).length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                  _createElementVNode("li", _hoisted_9, [
                    (!card.value.withHouse)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Всего участков "))
                      : (_openBlock(), _createElementBlock("p", _hoisted_11, " Всего домов ")),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(card.value.params.count), 1)
                  ]),
                  _createElementVNode("li", _hoisted_13, [
                    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "card-house__body-list-item-label" }, "Свободно", -1)),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(card.value.params.isFreeCount), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[1] || (_cache[1] = [
          _createElementVNode("p", null, "Нет данных", -1)
        ])))
  ], 4))
}
}

})